<template>
  <div class="card">
    <div class="card-header d-flex flex-row justify-content-between align-items-center w-100" v-if="title || $slots['header']">
      <div class="w-100" v-if="title">
        <h2 class="h3 card-title">
          <span class="icon h4" v-if="icon">
            <span :class="icon"></span>
          </span>
          <span>{{ title }}</span>
          <copyIcon v-if="copyVisible" :input="copyValue" :analyticsFieldName="analyticsFieldName" :analyticsCategory="analyticsCategory"></copyIcon>
        </h2>
      </div>
      <div class="d-flex w-100 flex-row justify-content-between" v-if="$slots['header']">
        <slot name="header"></slot>
      </div>
    </div>
    <div class="card-body" v-if="$slots['body']">
      <slot name="body"></slot>
    </div>
    <div class="card-footer" v-if="$slots['footer']">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import CopyIcon from '@/components/CopyIcon'

export default {
  name: 'Card',
  props: ['title', 'icon', 'copyVisible', 'copyValue', 'analyticsFieldName', 'analyticsCategory'],
  components: { CopyIcon }
}
</script>

<style scoped lang="scss">
  .copy-icon {
    margin-left: 10px;
  }
</style>
